import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { Button } from '../ui/Button';
import { useFetch } from '../../hooks/useFetch';
import { settingsApi } from '../../api/contentApi';
import { getCookieConsent, setCookieConsent, useCookieConsentReopen } from '../../hooks/useCookieConsent';
import './CookieConsent.css';

const MESSAGE_PAR_DEFAUT =
  "Nous n'utilisons aucun cookie de suivi par défaut. Avec votre accord, nous activons des outils de " +
  "mesure d'audience et de publicité (Google Analytics, Google Tag Manager, Meta Pixel) pour améliorer " +
  "le site. Vous pourrez changer d'avis à tout moment via « Gérer les cookies » dans le pied de page.";

export function CookieConsent() {
  const { data: settings } = useFetch(() => settingsApi.public(), []);
  const [visible, setVisible] = useState(() => getCookieConsent() === null);
  const [personnaliser, setPersonnaliser] = useState(false);
  const [analyticsChoix, setAnalyticsChoix] = useState(true);

  useCookieConsentReopen(() => {
    setPersonnaliser(false);
    setAnalyticsChoix(getCookieConsent()?.analytics ?? true);
    setVisible(true);
  });

  const banniereActivee = settings?.['cookies.actif'] !== '0';
  const doitSAfficher = visible && banniereActivee;

  useEffect(() => {
    document.body.classList.toggle('has-cookie-banner', doitSAfficher);
    return () => document.body.classList.remove('has-cookie-banner');
  }, [doitSAfficher]);

  if (!settings || !doitSAfficher) return null;

  const message = settings['cookies.message'] || MESSAGE_PAR_DEFAUT;

  function accepterTout() {
    setCookieConsent(true);
    setVisible(false);
  }

  function refuserTout() {
    setCookieConsent(false);
    setVisible(false);
  }

  function enregistrerChoix() {
    setCookieConsent(analyticsChoix);
    setVisible(false);
  }

  return (
    <div className="cookie-banner" role="dialog" aria-label="Gestion des cookies">
      <div className="cookie-banner__header">
        <span className="cookie-banner__icon" aria-hidden="true">
          <Cookie size={18} />
        </span>
        <p className="cookie-banner__text">
          {message} <Link to="/cookies">En savoir plus</Link>
        </p>
      </div>

      {personnaliser && (
        <label className="cookie-banner__toggle">
          <input
            type="checkbox"
            checked={analyticsChoix}
            onChange={(e) => setAnalyticsChoix(e.target.checked)}
          />
          <span>Mesure d'audience &amp; publicité (Google Analytics, GTM, Meta Pixel)</span>
        </label>
      )}

      <div className="cookie-banner__actions">
        {!personnaliser ? (
          <>
            <button type="button" className="btn btn--ghost cookie-banner__btn" onClick={() => setPersonnaliser(true)}>
              Personnaliser
            </button>
            <button type="button" className="btn btn--secondary cookie-banner__btn" onClick={refuserTout}>
              Refuser
            </button>
            <Button className="cookie-banner__btn" onClick={accepterTout}>
              Tout accepter
            </Button>
          </>
        ) : (
          <Button className="cookie-banner__btn" onClick={enregistrerChoix}>
            Enregistrer mes choix
          </Button>
        )}
      </div>
    </div>
  );
}
